<mat-card class="dialog-card">
  <mat-card-header class="custom-card-header">
    <mat-card-title class="custom-card-title">{{ data.title }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="dialog-content">
    <p class="dialog-message" [innerHTML]="data.message"></p>
  </mat-card-content>

  <mat-dialog-actions align="end" class="dialog-footer">
    <button mat-raised-button color="primary" mat-primary (click)="onCancel()">{{ data.cancelButtonText || 'Cancel' }}</button>
    <button mat-raised-button color="primary" mat-primary (click)="onConfirm()" cdkFocusInitial>
      {{ data.confirmButtonText || 'Confirm' }}
    </button>
  </mat-dialog-actions>
</mat-card>
